<template>
  <div id="intro">
    <div class="banner">
      <div class="content_box middle">
        <div class="logo"><img src="../../assets/images/suooter-logo.png" alt=""></div>
        <p v-for="item in $t('about.intro.merits')">{{item}}</p>
      </div>
    </div>
    <div class="feature mainWidth">
      <mu-row gutter class="feature_box">
        <mu-col width="100" tablet="100" desktop="100" class="video_box">
         <comvideoplayer :video="video"></comvideoplayer>
          <p class="intro">{{$t('about.intro.intro')}}</p>
        </mu-col>
      </mu-row>
    </div>
  </div>
</template>

<script>
  import comvideoplayer from '../../components/comvideoplayer.vue'
  export default {
    name: 'erange',
    data () {
      return {
        activeTab:'0',
        video:{"videoid":15,"videourl":"http://www.supershooter.cn:8099/UploadFile/Video/e94e3d1f-93e3-4511-9187-a8781e086ed1.mp4","videoimgurl":"http://www.supershooter.cn:8099/upfile/adinfo/Pic/201804/24152657.png","title":"速得尔宣传视频","createtime":"2018-03-14","describes":"\u003cp\u003e速得尔以创新技术服务中国射击事业！\u003c/p\u003e","playnumber":35,"duration":"03:00"}
      }
    },
    created(){

    },
    methods:{
      changeTab(idx){  //tab切换
        this.activeTab=idx;
      },
    },
    components:{comvideoplayer}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #intro{
    padding-bottom: 60px;
    .banner{
      height:414px;
      margin:0 auto;
      background:url("../../../static/guanyu-banner.png") no-repeat center center;
      background-size:auto 100%;
      position:relative;
      .content_box{
        width:1000px;
        height:auto;
        background-color:rgba(54,177,255,0.51);
        border-left:10px solid #6FA0FF;
        color:#FFF;
        padding:40px 60px 40px 95px;
        .logo{
          display:block;
          margin-bottom:20px;
          >img{
            width:132px;
            height:20px;
          }
        }
        >p{
          font-family: PingFangSC-Regular;
          text-align:justify;
          font-size: 14px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 27px;
        }
      }
    }
    .feature_box{
      overflow:hidden;
      background:#FFF;
      .video_box{
        width:750px;
        height:auto;
        margin:75px auto;
        .intro{
          font-family: PingFangSC-Regular;
          text-align:justify;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          line-height: 25px;
        }

      }
    }


  }

</style>




// WEBPACK FOOTER //
// src/page/childrens/intro.vue